import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loginService, logoutService, refreshTokenService } from "apis/Service";
import axios from 'axios';
import { Cookies } from 'react-cookie';
import { BASE_URL } from "store/baseConfig";

const cookies = new Cookies();
axios.defaults.baseURL = BASE_URL;
axios.defaults.withCredentials = true;

const login = createAsyncThunk(
    'auth/login',
    async (data, thunkAPI) => {

        const resp = await loginService(data)

        if (resp.status === 200) {

            return resp.data
        } else {
            return thunkAPI.rejectWithValue(resp)
        }
    }
)

const logout = createAsyncThunk(
    'auth/logout',
    async (data, thunkAPI) => {
        const { getState } = thunkAPI
        const { auth } = getState()
        const { loginState, loginUserInfo } = auth

        if (loginState) {
            try {
                const resp = await logoutService(loginUserInfo.refresh, loginUserInfo.access)
                console.log(resp)
                if (resp.status === 200) {
                    localStorage.removeItem('selectCompanyNo');
                    localStorage.removeItem('companyMenuItems');
                    localStorage.removeItem('contractDate');

                    return resp.data
                }
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response?.data || '로그아웃 실패');
            }
        }
        return thunkAPI.rejectWithValue('로그인 상태가 아닙니다');
    }
)

const refreshToken = createAsyncThunk(
    'auth/refreshToken',
    async (data, thunkAPI) => {
        const { getState } = thunkAPI
        const { auth } = getState()
        const { loginState, loginUserInfo } = auth
        try {
            const response = await refreshTokenService(loginUserInfo.refresh, loginUserInfo.access);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
)

const changePassword = createAsyncThunk(
    'auth/changePassword',
    async (data, { getState }) => {
        const { auth } = getState()
        const { loginState, loginUserInfo } = auth

        const { currentPassword, newPassword } = data

        const cookies = new Cookies();

        if (loginState) {

            const url = '/change-password/'
            const urlHeaders = {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': cookies.get('csrftoken')
                },
            }

            try {
                const resp = await axios.post(url, { currentPassword, newPassword }, urlHeaders)
                if (resp.status === 200) {
                    return resp.data
                }
            } catch (e) {
                console.log(e)
                throw new Error('비밀번호 변경 실패');
            }
        }
    }
)

const setLoginInfo = createAsyncThunk(
    'auth/setLoginInfo',
    async (data, thunkAPI) => {
        if (!data.access || !data.refresh || !data.user) {
            return thunkAPI.rejectWithValue('Invalid login info format');
        }
        return data;
    }
)

/*
    loginUserInfo: {
    "access": "",
    "refresh": "",
    "user": {
        "login_id": "",
        "perm_id": "",
        "corp_no": 123,
        "dept_no": 123,
        "empl_no": 1
    }
}
*/
export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        loginState: false,
        loginUserInfo: {}
    },
    extraReducers: (null, (builder) => {
        builder
            .addCase(login.pending, (state, action) => {

            }).addCase(login.fulfilled, (state, action) => {
                state.loginState = true;
                state.loginUserInfo = action.payload;
            }).addCase(login.rejected, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
            }).addCase(logout.pending, (state, action) => {

            }).addCase(logout.fulfilled, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
            }).addCase(logout.rejected, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
                cookies.remove('csrftoken');
            }).addCase(refreshToken.pending, (state, action) => {
            }).addCase(refreshToken.fulfilled, (state, action) => {
                state.loginState = true;
                state.loginUserInfo['access'] = action.payload.access;
                state.loginUserInfo['refresh'] = action.payload.refresh;
            }).addCase(refreshToken.rejected, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
            }).addCase(changePassword.pending, (state, action) => {

            }).addCase(changePassword.fulfilled, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
            }).addCase(changePassword.rejected, (state, action) => {

            }).addCase(setLoginInfo.fulfilled, (state, action) => {
                state.loginState = true;
                state.loginUserInfo = action.payload;
            }).addCase(setLoginInfo.rejected, (state, action) => {
                state.loginState = false;
                state.loginUserInfo = {};
            })
    })
});

export { changePassword, login, logout, refreshToken, setLoginInfo };

export default authSlice.reducer;